import type { AxiosResponse } from 'axios';
import { adminAxios } from 'utils/adminAxios';
import {
  contractsApprovedFindPath,
  contractsFindPath,
  contractsPendingFindPath,
} from './apis';

export const getContractsApprovedFind = async (): Promise<AxiosResponse> => {
  return await adminAxios.get(contractsApprovedFindPath());
};

export const getContractsPendingFind = async (): Promise<AxiosResponse> => {
  return await adminAxios.get(contractsPendingFindPath());
};

export const getContractsFind = async (id: string): Promise<AxiosResponse> => {
  return await adminAxios.get(contractsFindPath(id));
};
